import {Directive} from '@angular/core';
import {FormControl, NG_VALIDATORS} from "@angular/forms";

export function dateValidator(control: FormControl) {
  let val = control.value;

  if (val == null || val.trim() === "") {
    return null;
  }

  let day = new Date(val);

  if (+day > +new Date()) {
    return {
      invalidDate: "Invalid Date, Date cannot be after today"
    }
  }

  if (+day < +new Date("1990-01-01")) {
    return {
      invalidDate: "Invalid Date, Date cannot be before Jan 1st 1990"
    }
  }
  return null;
}

@Directive({
    selector: '[dateValidator][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useValue: dateValidator, multi: true }
    ],
    standalone: false
})
export class DateValidatorDirective {

  constructor() {
  }

}
